import React from "react";
import { useTranslation } from "react-i18next";
import { TextField } from "@material-ui/core";

const ZipcodeCommaSeparatedInput = ({
  label,
  value,
  onChange,
  errors,
  name,
  onBlur,
  disabled,
}) => {
  const { t } = useTranslation();

  const errorMsg =
    errors && errors[name]
      ? typeof errors[name] === "string"
        ? t(errors[name])
        : errors[name]
      : null;

  return (
    <TextField
      label={label}
      name={name}
      margin="dense"
      value={value ?? ""}
      onChange={onChange}
      onBlur={onBlur}
      fullWidth
      variant="filled"
      required
      disabled={disabled}
      error={!!errorMsg}
      helperText={errorMsg}
      inputProps={{
        autoComplete: "off",
      }}
    />
  );
};

export default ZipcodeCommaSeparatedInput;
